import { Task } from "../../../../../../services/cloudchipr.api";

export const taskTargetTagFilterText = ({ data }: { data?: Task }) => {
  return (
    data?.target?.tags?.map((tag) => `${tag.key} ${tag.value}`)?.join(" ") ?? ""
  );
};
